// @flow

import React, { Component } from 'react';
import './TextBox.css';

class TextBox extends Component {
  render() {
    const { enabled, filterName, label, onFilterChange, value } = this.props;

    const onValueChange = event => {
      onFilterChange({ filterName, enabled, value: event.target.value });
    };

    const onEnabledChange = event => {
      onFilterChange({ filterName, enabled: !enabled, value });
    };

    return (
      <div className="TextBox filter">
        <div className="top">
          <label>
            <input type="checkbox" onChange={onEnabledChange} checked={enabled} />
            {label}
          </label>
        </div>
        {enabled &&
          <div className="control">
            <input type="text" value={value} name={filterName} onChange={onValueChange} />
          </div>}
      </div>
    );
  }
}

export default TextBox;



// WEBPACK FOOTER //
// ./src/components/TextBox/TextBox.js